import { useState } from 'react';

export default function ContactMe() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok && response.status !== 400) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        setSubmitStatus('success');
        // Reset form
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
      
    } catch (error) {
      console.error('Contact form error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="Contact" className="contact--section">
      <div>
        <p className="sub--title">Get In Touch</p>
        <h2>Contact Me</h2>
        <p className="text-lg">
          If you have any questions, please feel free to contact me. I'll love to connect with you!
        </p>
      </div>
      <form className="contact--form--container" onSubmit={handleSubmit}>
        <div className="container">
          <label htmlFor="name" className="contact--label">
            <span className="text-md">Name</span>
            <input
              type="text"
              className={`contact--input text-md ${errors.name ? 'error' : ''}`}
              name="name"
              id="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
            {errors.name && <span className="error-message">{errors.name}</span>}
          </label>
          <label htmlFor="email" className="contact--label">
            <span className="text-md">Email</span>
            <input
              type="email"
              className={`contact--input text-md ${errors.email ? 'error' : ''}`}
              name="email"
              id="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </label>
        </div>
        <label htmlFor="subject" className="contact--label">
          <span className="text-md">Subject (Optional)</span>
          <input
            type="text"
            className={`contact--input text-md ${errors.subject ? 'error' : ''}`}
            name="subject"
            id="subject"
            value={formData.subject}
            onChange={handleInputChange}
            placeholder="Job opportunity, collaboration, etc."
          />
          {errors.subject && <span className="error-message">{errors.subject}</span>}
        </label>
        <label htmlFor="message" className="contact--label">
          <span className="text-md">Message</span>
          <textarea
            className={`contact--input text-md ${errors.message ? 'error' : ''}`}
            id="message"
            name="message"
            rows="8"
            placeholder="Type your message..."
            value={formData.message}
            onChange={handleInputChange}
            required
          />
          {errors.message && <span className="error-message">{errors.message}</span>}
        </label>
        
        {/* Status Messages */}
        {submitStatus === 'success' && (
          <div className="success-message">
            Message sent successfully! I'll get back to you soon.
          </div>
        )}
        {submitStatus === 'error' && (
          <div className="status-error-message">
            Failed to send message. Please try again or email me directly at chauyuhin1998@gmail.com
          </div>
        )}
        
        <button 
          type="submit" 
          className="btn btn-primary contact--form--btn"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </section>
  );
}
